import React, { useState } from 'react';
import {
	TextField,
	Grid,
	Typography,
	Divider,
	Button,
	Radio,
	FormControl,
	FormLabel,
	RadioGroup,
	FormControlLabel,
	Snackbar,
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import { useDispatch } from 'react-redux';
import AutoCompleteSelect from './AutoCompleteSelect';

const Alert = props => {
	return <MuiAlert elevation={6} variant='filled' {...props} />;
};

const ApplicantAddInfo = ({
	sendValueToParent,
	handleEmployer,
	handleProfession,
	handleSalaryNet,
	handleHomeAddress,
	handleEmploymentType,
	handleWorkCertificate,
	handleDistrictQuestion,
	handleGuardian,
	handleGuardianCertificate,
	handleMaritalStatus,
	handleMaritalStatusCertificate,
	handleHouseholdDisability,
	employerName,
	profession,
	salarynet,
	homeAddress,
	employmentType,
	workCertificate,
	districtQuestion,
	isGuardian,
	guardianCertificate,
	maritalStatus,
	maritalStatusCertificate,
	householdDisability,
	fieldError,
	provinces,
	province,
	handleProvince,
	districts,
	handleDistrictLocation,
	districtLocation,
	sectors,
	sector,
	handleSector,
	handleCell,
	cells,
	cell,
	handleVillage,
	village,
	villages,
	salary,
	fileInputError,
}) => {
	const { t } = useTranslation();

	const employmentStatus = [
		{ id: 1, status: 'Self-Employed', name: `${t('self-employed')}` },
		{ id: 2, status: 'Employed', name: `${t('employed')}` },
		{ id: 3, status: 'Unemployed', name: `${t('unemployed')}` },
	];

	const [open, setOpen] = useState(false);

	const handleCloseUpiErrorMessage = () => {
		setOpen(false);
	};

	const handleSubmitApplicantInfo = values => {
		// console.log(values);
	};

	const error = 'Salary must be less than 1500000';

	return (
		<div>
			{Number(salarynet) > 1500000 ? (
				<Snackbar
					anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
					open={open}
					autoHideDuration={6000}
					onClose={handleCloseUpiErrorMessage}
				>
					<Alert severity='error' onClose={handleCloseUpiErrorMessage}>
						{error}
					</Alert>
				</Snackbar>
			) : (
				''
			)}
			<Typography variant='h6' color='initial'>
				{t('applicant-details')}
			</Typography>
			<Divider />
			<Formik
				initialValues={{ gender: '' }}
				onSubmit={values => handleSubmitApplicantInfo(values)}
			>
				{props => (
					<Form onSubmit={props.handleSubmit}>
						<FormControl component='fieldset' margin='normal'>
							<FormLabel component='legend'>
								{t('disability-question')}
							</FormLabel>
							<div
								className={
									fieldError && fieldError === t('household-required')
										? 'overall-error'
										: 'overall-error-none'
								}
							>
								<RadioGroup
									name='householdDisability'
									onChange={handleHouseholdDisability}
								>
									<Grid container>
										<Grid item>
											<FormControlLabel
												value='Yes'
												control={<Radio color='default' />}
												label={t('guardian-yes')}
												checked={householdDisability === 'Yes'}
											/>
										</Grid>
										<Grid item>
											<FormControlLabel
												value='No'
												control={<Radio color='default' />}
												label={t('guardian-no')}
												checked={householdDisability === 'No'}
											/>
										</Grid>
									</Grid>
								</RadioGroup>
							</div>
						</FormControl>
						<Typography>{t('home-address')}</Typography>
						<AutoCompleteSelect
							options={provinces}
							onChange={handleProvince}
							value={province}
							label={t('province')}
							error={fieldError}
							errorLabel={t('province-required')}
						/>
						{province && (
							<AutoCompleteSelect
								options={districts}
								onChange={handleDistrictLocation}
								value={districtLocation}
								label={t('home-district')}
								error={fieldError}
								errorLabel={t('required-district')}
							/>
						)}
						{districtLocation && (
							<AutoCompleteSelect
								options={sectors}
								onChange={handleSector}
								value={sector}
								label={t('sector')}
								error={fieldError}
								errorLabel={t('sector-required')}
							/>
						)}
						{sector && (
							<AutoCompleteSelect
								options={cells}
								onChange={handleCell}
								value={cell}
								label={t('cell')}
								error={fieldError}
								errorLabel={t('cell-required')}
							/>
						)}
						{cell && (
							<AutoCompleteSelect
								options={villages}
								onChange={handleVillage}
								value={village}
								label={t('village')}
								error={fieldError}
								errorLabel={t('village-required')}
							/>
						)}
						<TextField
							type='text'
							value={salary}
							variant='outlined'
							size='small'
							margin='normal'
							fullWidth
							required={true}
							label={t('income')}
							id='salarynet'
							name='salarynet'
							onChange={handleSalaryNet}
							error={
								fieldError.length > 0 && fieldError === t('income-required')
							}
						/>
						<TextField
							id='employmentType'
							name='employmentType'
							select
							size='small'
							margin='normal'
							variant='outlined'
							label={t('employment-status')}
							fullWidth
							required={true}
							onChange={handleEmploymentType}
							defaultValue={employmentType}
							SelectProps={{
								native: true,
							}}
							error={
								fieldError.length > 0 &&
								fieldError === t('employmentType-required')
							}
						>
							<option aria-label='None' value='' />
							{employmentStatus.length === 0
								? 'Loading...'
								: employmentStatus.map(({ id, status, name }) => (
										<option key={id} value={status}>
											{name}
										</option>
								  ))}
						</TextField>
						{employmentType === 'Self-Employed' ||
						employmentType === 'Employed' ? (
							<div
								className={
									fieldError && fieldError === t('workCertificate-required')
										? 'upload-error'
										: 'upload-error-none'
								}
							>
								<Grid container direction='column'>
									<Grid item>
										<label htmlFor=''>{t('work-certificate')}</label>
									</Grid>
									<Grid item>
										<Grid container spacing={2}>
											<Grid item>
												<input
													style={{ display: 'none' }}
													id='workCertificate'
													multiple
													type='file'
													onChange={handleWorkCertificate}
												/>
												<label htmlFor='workCertificate'>
													<Button
														variant='contained'
														color='default'
														component='span'
														startIcon={<CloudUploadIcon />}
													>
														Upload
													</Button>
												</label>
											</Grid>
											<Grid item>
												<Typography component='span' color='primary'>
													{workCertificate && workCertificate.name}
												</Typography>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</div>
						) : (
							''
						)}
						{employmentType === 'Employed' ? (
							<>
								<TextField
									variant='outlined'
									size='small'
									margin='normal'
									fullWidth
									required={true}
									label={t('employer')}
									id='employerName'
									name='employerName'
									onChange={handleEmployer}
									defaultValue={employerName}
									error={
										fieldError.length > 0 &&
										fieldError === t('employerName-required')
									}
								/>
								<TextField
									variant='outlined'
									size='small'
									margin='normal'
									fullWidth
									required={true}
									label={t('profession')}
									onChange={handleProfession}
									defaultValue={profession}
									error={
										fieldError.length > 0 &&
										fieldError === t('profession-required')
									}
								/>
							</>
						) : employmentType === 'Self-Employed' ? (
							<TextField
								variant='outlined'
								size='small'
								margin='normal'
								fullWidth
								required={true}
								label={t('profession')}
								onChange={handleProfession}
								defaultValue={profession}
								error={
									fieldError.length > 0 &&
									fieldError === t('profession-required')
								}
							/>
						) : (
							''
						)}

						{maritalStatus === 'Single' && (
							<div
								className={
									fieldError &&
									fieldError === t('maritalStatusCertificate-required')
										? 'upload-error'
										: 'upload-error-none'
								}
							>
								<Grid container direction='column'>
									<Grid item>
										<label htmlFor=''>{t('single-certificate')}</label>
									</Grid>
									<Grid item>
										<Grid container spacing={2}>
											<Grid item>
												<input
													style={{ display: 'none' }}
													id='maritalStatusCertificate'
													multiple
													type='file'
													onChange={handleMaritalStatusCertificate}
													accept=".pdf,.jpg,.png,.jpeg"
												/>
												<label htmlFor='maritalStatusCertificate'>
													<Button
														variant='contained'
														color='default'
														component='span'
														startIcon={<CloudUploadIcon />}
													>
														Upload
													</Button>
												</label>
											</Grid>
											<Grid item>
												<Typography component='span' color='primary'>
													{maritalStatusCertificate &&
														maritalStatusCertificate.name}
												</Typography>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</div>
						)}
					</Form>
				)}
			</Formik>
		</div>
	);
};

export default ApplicantAddInfo;
